@if (tier.isReadOnly()) {
  <div class="subscription-banner" role="status">
    <span class="subscription-banner-text">
      @switch (tier.grantKind()) {
        @case ('TRIAL') { {{ (canManageBilling() ? 'billing.subscriptionBanner.trialEnded' : 'billing.subscriptionBanner.trialEndedPlain') | translate }} }
        @case ('SUBSCRIPTION') { {{ (canManageBilling() ? 'billing.subscriptionBanner.subscriptionEnded' : 'billing.subscriptionBanner.subscriptionEndedPlain') | translate }} }
        @case ('COMP') { {{ (canManageBilling() ? 'billing.subscriptionBanner.compEnded' : 'billing.subscriptionBanner.compEndedPlain') | translate }} }
      }
      @if (showsDeferredImages()) {
        <span class="subscription-banner-line" data-line="deferred-images">{{ (canManageBilling() ? 'billing.trialBanner.deferredImages' : 'billing.trialBanner.deferredImagesPlain') | translate }}</span>
      }
      @switch (pauseLine()) {
        @case ('pauseOn') {
          <span class="subscription-banner-line" data-line="public-pages">{{ 'billing.subscriptionBanner.publicPages.pauseOn' | translate: { date: (tier.publicFacesPauseAt() | displayDate:'medium':zone()) } }}</span>
        }
        @case ('paused') {
          <span class="subscription-banner-line" data-line="public-pages">{{ 'billing.subscriptionBanner.publicPages.paused' | translate }}</span>
        }
      }
    </span>
    @if (canManageBilling()) {
      <a routerLink="/admin/settings/plan-usage" class="subscription-banner-cta">
        {{ 'billing.viewPlans' | translate }}
      </a>
    } @else {
      <span class="subscription-banner-text">{{ 'billing.subscriptionBanner.askOwner' | translate }}</span>
    }
  </div>
}
